import { render, staticRenderFns } from "./MySelect.vue?vue&type=template&id=6bf283f6&scoped=true&"
import script from "./MySelect.vue?vue&type=script&lang=js&"
export * from "./MySelect.vue?vue&type=script&lang=js&"
import style0 from "./MySelect.vue?vue&type=style&index=0&id=6bf283f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf283f6",
  null
  
)

export default component.exports